import { render, staticRenderFns } from "./BCheckbox.vue?vue&type=template&id=1f064176"
import script from "./BCheckbox.vue?vue&type=script&lang=ts"
export * from "./BCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./BCheckbox.vue?vue&type=style&index=0&id=1f064176&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports